export default __webpack_public_path__ + "static/echo-panc-5fb5baf151ec4e1150828d0ccf667fb1.png";